import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { InputFieldComponent } from 'src/app/components/form/input-field/input-field.component';
import { AlertInfo } from 'src/app/models/alert-info';
import { SavedDataInfo } from 'src/app/models/form/saved-data-info';
import { AlertNotificationService } from 'src/app/services/alert-notification.service';
import { ProposalsService } from 'src/app/services/api/proposals.service';
import { FormService } from 'src/app/services/form.service';
import { ValidatorService } from 'src/app/services/validator.service';

@Component({
  selector: 'settings-payment-terms-form',
  imports: [NgbAlert, InputFieldComponent, ReactiveFormsModule],
  templateUrl: './settings-payment-terms-form.component.html',
  styleUrl: './settings-payment-terms-form.component.scss'
})
export class SettingsPaymentTermsFormComponent {
  @Input() paymentTerm?: any;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private proposalsService: ProposalsService,
    private location: Location,
  ) { }


  ngOnInit(): void {
    this.form = new FormGroup({
      code: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      position: new FormControl(null, Validators.required),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['paymentTerm'] && changes['paymentTerm'].currentValue) {
      this.form.patchValue({
        code: this.paymentTerm.code,
        name: this.paymentTerm.name,
        position: this.paymentTerm.position,
      });
    }
  }

  /**
   * *******************
   * Submit form methods
   * *******************
   */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {

      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const serviceMethod = this.paymentTerm ? this.proposalsService.updateSettingsPaymentTerms(this.paymentTerm.proposalPaymentConditionTypeId, values) : this.proposalsService.createSettingsPaymentTerms(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }

  goBack(): void {
    this.location.back();

  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */



  getItemTypeCodeInput(): FormControl { return this.getFormControl('code'); }
  getItemTypeNameInput(): FormControl { return this.getFormControl('name'); }
  getItemTypePositionInput(): FormControl { return this.getFormControl('position'); }
  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}
